import request from '@/utils/request'
// huzhou/getPrograms?type=1&page=1&pageSize=10
export const userLogin = (data) => {
  return request({
    method: 'POST',
    url: '/login/userLogin',
    data,
  })
}

export const getWorksList = (params) => {
  return request({
    method: 'GET',
    url: '/huzhou/getPrograms',
    params,
  })
}

export const worksVote = (data) => {
  return request({
    method: 'POST',
    url: '/huzhou/programVoteForAll',
    data,
  })
}

export const getVoteRankList = (params) => {
  return request({
    method: 'GET',
    url: '/huzhou/getRankingList',
    params,
  })
}
export const getMainData = (params) => {
  return request({
    method: 'GET',
    url: '/huzhou/getMainData',
    params,
  })
}
export const userAccess = (params) => {
  return request({
    method: 'POST',
    url: '/huzhou/userAccess',
    params,
  })
}
export const wxUserAccess = (params) => {
  return request({
    method: 'POST',
    url: '/huzhou/wx/userAccess',
    params,
  })
}
export const searchProgram = (params) => {
  return request({
    method: 'GET',
    url: '/huzhou/searchProgram',
    params,
  })
}

export const getAssistedPrograms = () => {
  return request({
    method: 'GET',
    url: '/huzhou/getAssistedPrograms',
  })
}

export const getVoteNum = () => {
  return request({
    method: 'GET',
    url: '/huzhou/getVoteNum',
  })
}
export const browseProgram = (params) => {
  return request({
    method: 'GET',
    url: '/huzhou/browseProgram',
    params,
  })
}
export const getOpenId = (params) => {
  return request({
    method: 'GET',
    url: '/huzhou/wx/getOpenId',
    params,
  })
}
export const programVote = (data) => {
  return request({
    method: 'POST',
    url: '/huzhou/wx/programVote',
    data,
  })
}
export const getWxAssistedPrograms = (params) => {
  return request({
    method: 'GET',
    url: '/huzhou/wx/getAssistedPrograms',
    params,
  })
}
// /wx/programVote
// {
// openId:
// programIds:

// }

// /wx/getAssistedPrograms?openId=
